import ValidatorHelper from 'viralstyle-ui/src/ValidatorHelper';

export const loginValidator = new ValidatorHelper({
  username: {
    rules: 'required|email',
    pretty: 'email'
  },
  password: {
    rules: 'required|min:8',
    pretty: 'password'
  }
});

export const newProductValidator = new ValidatorHelper({
  colors: {
    rules: 'required|min_value:1',
    pretty: 'colors',
  }
});